<div class="media-thumbnail">
  @if (isVideo) {
    <video class="thumbnail-img" [src]="thumbnailUrl" muted playsinline preload="metadata"></video>
    <div class="play-overlay">
      <div class="play-icon"></div>
    </div>
  } @else {
    <img class="thumbnail-img" [src]="thumbnailUrl" [alt]="altText"/>
  }
</div>
